import DataTable from '../DataTable';
import type { ScaleOrdinal } from 'd3-scale';
import { Row, LabelWrapper } from './styled';

interface Props {
  title: string;
  keys: string[];
  /**
   * A set of labels to display for each key.
   * If not provided the keys themselves will be displayed directly.
   *
   * Added as a backward-compatible way to support localised labels.
   */
  keyLabels?: Record<string, string>;
  color: ScaleOrdinal<string, string>;
  entities: Record<string, number | null>;
  formatter: (value: number | null, significance?: number) => string;
}

export const Label = ({
  title,
  keys,
  keyLabels,
  entities,
  color,
  formatter,
}: Props) => {
  return (
    <LabelWrapper>
      <DataTable width="144px">
        <thead>
          <tr>
            <th colSpan={2}>{title}</th>
          </tr>
        </thead>
        <tbody>
          {keys.map((key) => (
            <Row key={`gauge-label-${key}-${entities[key]}`} color={color(key)}>
              <td data-cy-id={`gauge-chart-${title}-pin-${key}-title`}>
                {keyLabels?.[key] ?? key}
              </td>
              <td data-cy-id={`gauge-chart-${title}-pin-${key}-value`}>
                {formatter(entities[key], 1)}
              </td>
            </Row>
          ))}
        </tbody>
      </DataTable>
    </LabelWrapper>
  );
};
